import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from "react-redux";
import * as actionTypes from "@redux/actionTypes";
import { useAuth } from "@context";
import { getStatusRide } from "@services/api";
import { safeLocalStorage } from '@utils/localstorage';

import LifePoint from '@images/dashboard/lifepoint.svg';
import RiSteering from '@images/dashboard/ri_steering-fill.svg';
import ProfilePic from '@images/profilePic.png';
import Heart from '@images/dashboard/Heart.svg';
import FBTToken from '@images/dashboard/FBTToken.svg';
import BuyGamePassBg from '@images/dashboard/buyGamePassBg.png';
import DrivingWhiteSteering from "@images/drivingWhite.png";
import CloseIcon from '@images/dashboard/close.svg';
import ArrowUpIcon from '@images/dashboard/ArrowUp.svg';

const Profile = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    const { apiLoading } = useAuth();
    const [isVisible, setIsVisible] = useState(false);
    const [currentSequence, setCurrentSequence] = useState()
    const [drivingBotData, setDrivingBotData] = useState('')
    const [showReturnDrive, setShowReturnDrive] = useState(false)
    const [playbotAccess, setPlayBotAccess] = useState(false)

    // State Selectors
    const user = useSelector((state) => state.setUserDetails.user);
    const fullLicenceMetaData = useSelector((state) => state.minting.fullLicenceMetaData);
    const coinInputNumberDefault = useSelector((state) => state.coinName.coinInputNumberDefault);
    const allBots = useSelector((state) => state.botDetail.allBot);

    // Constants
    const Bucket_url = process.env.NEXT_PUBLIC_DELIEVERY_CONTENT_URL;
    const ProfilePicture = user?.avatar_url ? `${Bucket_url}${user?.avatar_url}` : ProfilePic;
    const frodoPoints = user.frodo_points;
    const displayFrodoPoints = frodoPoints % 1 !== 0 ? frodoPoints?.toFixed(2) : frodoPoints;
    const drivingBot = safeLocalStorage.getItem("drivingBot")
    const token = safeLocalStorage.getItem("token")

    useEffect(() => {
        if (allBots?.length > 0) {
            handleReturnDriveMission(allBots)
        }
    }, [allBots]);

    const buyTcHandler = () => {
        dispatch({
            type: actionTypes.BUY_TC,
            payload: true,
        });
        dispatch({
            type: actionTypes.COIN_BALANCE_NUMBER,
            payload: coinInputNumberDefault,
        });
    };

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const profileModelHandler = () => {
        dispatch({
            type: actionTypes.PROFILE_MODEL,
            payload: true,
        });
    }

    const openInDriveNowUrl = () => {
        const rideSequence = drivingBot?.deviceId ? drivingBot?.deviceId : drivingBotData?.deviceId
        safeLocalStorage.setItem(`ride_sequence_${rideSequence}`, currentSequence)
        safeLocalStorage.setItem('drivingBot', drivingBotData)
        router.push('/openworldplaycontrollers');
    };

    const openInPlayUrl = () => {
        router.push(`/testdrivecontroller`)
    }

    const handleReturnDriveMission = async (bots) => {
        bots.forEach(async (bot) => {
            if (bot?.current_ride_id) {
                const rideStatus = await getStatusRide(bot?.current_ride_id);
                if (rideStatus?.ride && isUserRideCheck(rideStatus, bot)) {
                    if (isTrialMode(bot)) {
                        dispatch({ type: actionTypes.TESTDRIVE_RIDE_ID, payload: rideStatus.ride.id });
                        setPlayBotAccess(true);
                    } else if (isCheckDriveMode(bot)) {
                        setupDrivingBotData(bot, rideStatus);
                    }
                }
            }
        });
    };

    const isUserRideCheck = (rideStatus, bot) => {
        return (
            rideStatus?.ride?.user_id === token?.user?.id &&
            ['active', 'visible'].includes(rideStatus?.ride?.status) &&
            bot?.status === "mission_in_progress"
        );
    };

    const isTrialMode = (bot) => {
        const tournamentData = safeLocalStorage.getItem('tournamentData')
        const agoraToken = safeLocalStorage.getItem(`agoratoken_${tournamentData?.deviceId}`)
        return agoraToken && tournamentData?.deviceId && bot.drive_mode === 'trial';
    };

    const isCheckDriveMode = (bot) => ['mission', 'personal'].includes(bot?.drive_mode);

    const setupDrivingBotData = (bot, rideStatus) => {
        setShowReturnDrive(true);
        setCurrentSequence(rideStatus.ride.current_sequence);
        setDrivingBotData({
            deviceId: bot?.device_ref_id,
            missionId: rideStatus?.ride?.mission_id,
            hardware_version: bot?.hardware_version,
            speed_control_profile: bot?.speed_control_profile   && Object.keys(bot?.speed_control_profile).length > 0
                ? bot?.speed_control_profile
                : ''
        });
    };

    return (
        <div className='flex flex-col items-start gap-[16px]'>
            {showReturnDrive &&
                <button className='w-[280px] flex pl-[12px] pr-[16px] py-[12px] justify-center items-center rounded-[50px] bg-[#25BD66]' onClick={openInDriveNowUrl}>
                    <div className='flex items-center gap-[6px]'>
                        <img
                            src={DrivingWhiteSteering}
                            alt="DrivingWhiteSteering-icon"
                        />
                        <p className='text-[#FAFAFA] text-center text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>Return to mission</p>
                    </div>
                </button>
            }
            {playbotAccess &&
                <button className='w-[280px] flex pl-[12px] pr-[16px] py-[12px] justify-center items-center rounded-[50px] bg-[#25BD66]' onClick={openInPlayUrl}>
                    <div className='flex items-center gap-[6px]'>
                        <img
                            src={DrivingWhiteSteering}
                            alt="DrivingWhiteSteering-icon"
                        />
                        <p className='text-[#FAFAFA] text-center text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>Return to playgame</p>
                    </div>
                </button>
            }
            {(!apiLoading && (fullLicenceMetaData?.statusOfPass === 'minting' || fullLicenceMetaData?.life_point)) ?
                <div className='w-[280px] flex pl-[12px] pr-[16px] py-[12px] justify-between items-center rounded-[50px] bg-[#FAFAFA]'>
                    {/* <button className='flex px-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-[solid] border-[#008735] bg-[#25BD66]' onClick={buyTcHandler}>
                        <p className='text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Buy TC</p>
                    </button> */}
                    <div className='flex items-center gap-[6px]'>
                        <img
                            src={RiSteering}
                            alt="RiSteering-icon"
                        />
                        <p className='text-[#000] text-center text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>{user.time_credit} TC</p>
                    </div>
                </div>
                :
                (!apiLoading && fullLicenceMetaData?.life_point <= 0) &&
                <div className='flex w-[280px] h-[250px] flex-col justify-end items-start'>
                    <img
                        src={LifePoint}
                        alt="LifePoint-icon"
                    />
                    <div className='flex w-[280px] pl-[8px] pr-[8px] py-[16px] flex-col items-start gap-[16px] rounded-[30px] border-[2px] border-[solid] border-[#25BD66] bg-cover bg-center' style={{ backgroundImage: `url(${BuyGamePassBg})` }}>
                        <div className='flex px-[14px] py-0 flex-col items-center gap-[4px]'>
                            <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>Get LPs to unlock missions!</p>
                            <p className='text-[#FAFAFA] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Every failed mission will cost you 1 Life Point (LP).</p>
                        </div>
                        {/* <Link
                            to="/buy-gamepass"
                            className='w-full flex h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] bg-[#25BD66]'>
                            <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>Buy Game Pass</p>
                        </Link> */}
                    </div>
                </div>
            }
            <div className='w-[300px] flex items-center'>
                <button className='w-[280px] flex h-[56px] p-[4px] items-center gap-[8px] rounded-[50px] bg-[#FAFAFA]' onClick={profileModelHandler}>
                    <div className='w-full flex px-[8px] py-[4px] items-center gap-[8px] rounded-[500px] bg-[#D5D9FF]'>
                        <img
                            src={ProfilePicture}
                            alt="UserProfile"
                            style={{ borderRadius: '50%', width: '32px', height: '32px' }}
                        />
                        <div className='flex flex-col items-start w-full'>
                            <div className='flex items-center gap-[4px]'>
                                <p className='text-[#000] text-left leading-[20px] not-italic font-bold text-[16px] tracking-[-0.64px] overflow-ellipsis overflow-hidden w-[200px] whitespace-nowrap'>{user.username}</p>
                            </div>
                            <div className='flex items-start gap-[16px]'>
                                <div className='flex items-center gap-[2px]'>
                                    <img
                                        src={Heart}
                                        alt="Heart"
                                    />
                                    <p className='text-[#727272] text-[16px] not-italic font-medium leading-[20px] tracking-[-0.64px]'>: {fullLicenceMetaData?.life_point}</p>
                                </div>
                                <p className='text-[#727272] text-[16px] not-italic font-medium leading-[20px] tracking-[-0.64px]'>XP: {user?.experience_points}</p>
                                <div className='flex items-center gap-[2px]'>
                                    <img
                                        src={FBTToken}
                                        alt="3DFBTToken"
                                    />
                                    <p className='text-[#727272] text-[16px] not-italic font-medium leading-[20px] tracking-[-0.64px]'>: {displayFrodoPoints}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </button>
                <button onClick={toggleVisibility}>
                    <img src={ArrowUpIcon} alt="ArrowUpIcon" />
                </button>
            </div>
            {isVisible && (
                <div className='absolute left-[300px] bottom-[-10px]'>
                    <div className='flex w-[291px] p-[16px] flex-col justify-center items-center gap-[16px] rounded-[16px] bg-[#FAFAFA]'>
                        <div className='flex flex-col justify-center items-center gap-[4px]'>
                            <div className='w-full flex justify-between items-center gap-[4px]'>
                                <p className='text-[#0057D5] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>View your stats and more!</p>
                                <button onClick={toggleVisibility}>
                                    <img src={CloseIcon} alt="CloseIcon" />
                                </button>
                            </div>
                            <p className='text-[#727272] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>Click on your profile to see your TCs, LP, and drive history!</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Profile